<div class="forgot-password-body">
  <mat-card appearance="outlined" class="example-card">
    <mat-card-content>
      <h2 class="text-center">Forgot Password</h2>
      <form (ngSubmit)="onSubmit()" [formGroup]="forgotPasswordForm">
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 325px">
            <mat-label>Email</mat-label>
            <input formControlName="email" id="email" matInput name="email" type="email">
            <mat-error *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched">
              Please enter a valid email address.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-row-login-btn">
          <button class="submitBtn" color="primary" mat-raised-button type="submit" [disabled]="loading || forgotPasswordForm.invalid">
            <mat-progress-spinner *ngIf="loading" diameter="20" mode="indeterminate"></mat-progress-spinner>
            <span *ngIf="!loading">Reset Password</span>
          </button>
        </div>
      </form>
      <div class="text-center">
        <a routerLink="/">Back to Login</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>
